import React, { useEffect, useState } from 'react';
import { LockIcon } from 'lucide-react';
const STORAGE_KEY = 'realrates-unlocked';
interface PasscodeGateProps {
  /** Shared crew passcode. Change this to rotate access. */
  passcode: string;
  children: React.ReactNode;
}

/**
 * Keeps the supplier cost basis off the public web. This is a deterrent, not
 * real security — the page ships to the browser either way — so it's paired
 * with a noindex tag and a robots.txt disallow on the route.
 */
export function PasscodeGate({
  passcode,
  children
}: PasscodeGateProps) {
  const [unlocked, setUnlocked] = useState(false);
  const [entry, setEntry] = useState('');
  const [error, setError] = useState(false);
  useEffect(() => {
    try {
      setUnlocked(window.localStorage.getItem(STORAGE_KEY) === passcode);
    } catch {
      // Storage can throw in private mode; fall through to the locked state.
    }
  }, [passcode]);
  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (entry.trim() !== passcode) {
      setError(true);
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, passcode);
    } catch {
      // Non-fatal: the session still unlocks, it just won't be remembered.
    }
    setUnlocked(true);
  }
  if (unlocked) return <>{children}</>;
  return <div className="flex min-h-full w-full items-center justify-center bg-canvas px-6 py-24" data-id="element-93" data-mp="nio2xbmagess">
      <form onSubmit={handleSubmit} className="w-full max-w-sm rounded-xl border border-line bg-surface p-6" data-id="element-94" data-mp="11ifdf2dljd21">
        <LockIcon className="h-5 w-5 text-ink-soft" aria-hidden="true" data-id="element-95" data-mp="wj2psfewi1ye" />
        <h1 className="mt-3 text-lg font-semibold text-ink" data-id="element-96" data-mp="1b91nyi6ghddv">Crew access only</h1>
        <p className="mt-1 text-sm text-ink-muted" data-id="element-97" data-mp="169xhhzax1tr8">
          This page shows supplier cost basis. Enter the shared passcode to continue.
        </p>

        <label className="mt-5 block text-xs font-medium uppercase tracking-wide text-ink-soft" data-id="element-98" data-mp="1k9zrz0gw9kwg">
          Passcode
          <input type="password" value={entry} onChange={event => {
          setEntry(event.target.value);
          setError(false);
        }} autoFocus className="mt-1 h-10 w-full rounded-lg border border-line bg-canvas px-3 text-sm normal-case tracking-normal text-ink outline-none transition-colors duration-150 focus:border-accent" data-id="element-99" data-mp="1f8aj9rh59jbj" />
        </label>

        {error && <p role="alert" className="mt-2 text-sm text-accent" data-id="element-100" data-mp="vmdvdc2k7j51">
            That passcode doesn't match.
          </p>}

        <button type="submit" className="mt-4 w-full rounded-lg bg-ink px-4 py-2 text-sm font-medium text-white transition-colors duration-150 hover:bg-accent" data-id="element-101" data-mp="10kp57msuttn9">
          Unlock
        </button>
      </form>
    </div>;
}